import { type CanvasAndContext } from './canvas.types';

export function createCanvas(
  width: number,
  height: number
): CanvasAndContext | undefined {
  if (
    Number.isFinite(width) && width > 0
    && Number.isFinite(height) && height > 0
  ) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const context = canvas.getContext('2d');
    if (context) {
      return { canvas, context };
    }
  }

  return undefined;
}
